import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import { getSchemaForStep } from "./validation";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { Box, Button, LinearProgress, Stack, Badge, Alert, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from "@mui/material";
import { loadFromLocalStorage, clearFromLocalStorage, debounce, saveToLocalStorage, } from "@corporate-trip-planner-fe/ui-components";
import { TripPrivacyType, } from "../../../components/trips/create-trip/v2/CreateTripForm.type";
import TripBasicsForm from "../../../components/trips/create-trip/v2/TripBasicsForm";
import PrivacyParticipantsForm from "../../../components/trips/create-trip/v2/PrivacyParticipantsForm";
import ItineraryLogisticsForm from "../../../components/trips/create-trip/v2/ItineraryLogisticsForm";
import ReviewPublishStep from "../../../components/trips/create-trip/v2/ReviewPublishStep";
import { setLoading, setSnackbar, setModal } from "../../../store/slices";
import { ModalKeys } from "../../../components/modal/modalKeys";
import { createTrip, updateTrip, uploadFile, getTripCategories, } from "../../../services/api/EventCreationServices";
import { StatusCodes } from "../../../utils/enums/StatusCode";
import endpoints from "../../../services/endpoints";
import { getTripDetails } from "../../../services/api/TripDetailsService";
import dayjs from "dayjs";
import { CREATE_TRIP_KEY } from "../utils";
import TripSuccessStep from "./../../../components/trips/create-trip/v2/TripSuccessStep";
import TripDetailsForm from "./../../../components/trips/create-trip/v2/TripDetailsForm";
import { CreateTripFormInitialData } from "./../../../components/form/create-trip-form/InitialData";
var DATE_FORMAT = "DD-MM-YYYY";
/* const initialTripData: CreateTripFormData = {
  // Step 1
  tripTitle: "",
  source: "",
  destination: "",
  startDate: null,
  endDate: null,
  tripCategories: [],
  description: "",
  highlights: [],
  coverImage: null,
  coverImageFile: null,
  modeOfTransport: "",
  meetingTime: "",
  meetingPoint: "",
  inclusions: [],
  exclusions: [],
  // Step 2
  privacy: TripPrivacyType.COMPANY_ONLY,
  allowJoinRequests: true,
  maxParticipants: 1,
  invitedParticipants: [],

  // --- Step 3: Itinerary & Logistics ---
  itinerary: [
    {
      id: "day-1",
      day: String(1),
      title: "Day 1",
      description: "Day 1 looks like",
      activities: [
        {
          id: "act-1",
          time: "",
          title: "",
          location: "",
          description: "",
        },
      ],
    },
  ],
  logistics: {
    accommodation: {
      hotelName: "",
      address: "",
      checkIn: null,
      checkOut: null,
      confirmationFile: null,
    },
    transport: {
      number: "",
      tickets: null,
    },
  },
}; */
var mapApiPrivacyToWizard = function (privacy) {
    switch (privacy) {
        case "public":
            return TripPrivacyType.PUBLIC;
        case "approval":
            return TripPrivacyType.INVITE_ONLY;
        case "invite-only":
            return TripPrivacyType.INVITE_ONLY;
        default:
            return TripPrivacyType.COMPANY_ONLY;
    }
};
var serializeDraft = function (data) {
    var _a, _b, _c, _d;
    return (__assign(__assign({}, data), { startDate: (_b = (_a = data.startDate) === null || _a === void 0 ? void 0 : _a.format("DD-MM-YYYY")) !== null && _b !== void 0 ? _b : null, endDate: (_d = (_c = data.endDate) === null || _c === void 0 ? void 0 : _c.format("DD-MM-YYYY")) !== null && _d !== void 0 ? _d : null }));
};
var deserializeDraft = function (data) { return (__assign(__assign({}, data), { startDate: (data === null || data === void 0 ? void 0 : data.startDate) ? dayjs(data.startDate, "DD-MM-YYYY") : null, endDate: (data === null || data === void 0 ? void 0 : data.endDate) ? dayjs(data.endDate, "DD-MM-YYYY") : null })); };
var parseBudgetPayload = function (budget) {
    if (!(budget === null || budget === void 0 ? void 0 : budget.itemAmounts))
        return undefined;
    var budgetItems = Object.entries(budget.itemAmounts)
        .filter(function (_a) {
        var amount = _a[1];
        return amount !== "" && amount != null && Number(amount) > 0;
    })
        .map(function (_a) {
        var categoryCode = _a[0], amount = _a[1];
        return ({
            categoryCode: categoryCode,
            amount: Number(amount),
        });
    });
    if (budgetItems.length === 0)
        return undefined;
    return {
        currency: budget.currency || "INR",
        budgetItems: budgetItems,
    };
};
/** Trip details API historically returned category id as value; create/update expects codes. */
var normalizeTripCategoriesForForm = function (categories) { return __awaiter(void 0, void 0, void 0, function () {
    var master, masterByLabel, masterByCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!categories.length)
                    return [2 /*return*/, []];
                return [4 /*yield*/, getTripCategories()];
            case 1:
                master = _a.sent();
                masterByLabel = new Map(master.map(function (c) { return [c.label, c]; }));
                masterByCode = new Map(master.map(function (c) { return [String(c.value), c]; }));
                return [2 /*return*/, categories
                        .map(function (cat) {
                        var _a;
                        var raw = String(cat.value);
                        if (masterByCode.has(raw)) {
                            return masterByCode.get(raw);
                        }
                        if (/^\d+$/.test(raw)) {
                            return (_a = masterByLabel.get(cat.label)) !== null && _a !== void 0 ? _a : null;
                        }
                        return { value: raw, label: cat.label };
                    })
                        .filter(function (cat) { return cat != null && Boolean(cat.value); })];
        }
    });
}); };
var mapTripToWizardData = function (trip) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    return {
        tripTitle: (_a = trip.tripName) !== null && _a !== void 0 ? _a : "",
        source: (_b = trip.source) !== null && _b !== void 0 ? _b : "",
        destination: (_c = trip.destination) !== null && _c !== void 0 ? _c : "",
        startDate: trip.startDate ? dayjs(trip.startDate, DATE_FORMAT) : undefined,
        endDate: trip.endDate ? dayjs(trip.endDate, DATE_FORMAT) : undefined,
        tripCategories: (_d = trip.tripCategories) !== null && _d !== void 0 ? _d : [],
        description: (_e = trip.description) !== null && _e !== void 0 ? _e : "",
        highlights: (_f = trip.highlights) !== null && _f !== void 0 ? _f : [],
        coverImage: (_g = trip.coverImageUrl) !== null && _g !== void 0 ? _g : null,
        coverImageFile: null,
        modeOfTransport: (_h = trip.modeOfTransport) !== null && _h !== void 0 ? _h : "",
        meetingTime: (_k = (_j = trip.locationDetails) === null || _j === void 0 ? void 0 : _j.meetingTime) !== null && _k !== void 0 ? _k : "",
        meetingPoint: (_m = (_l = trip.locationDetails) === null || _l === void 0 ? void 0 : _l.meetingPoint) !== null && _m !== void 0 ? _m : "",
        inclusions: (_o = trip.inclusions) !== null && _o !== void 0 ? _o : [],
        exclusions: (_p = trip.exclusions) !== null && _p !== void 0 ? _p : [],
        budget: {
            currency: (_r = (_q = trip.budgetDetails) === null || _q === void 0 ? void 0 : _q.currency) !== null && _r !== void 0 ? _r : "INR",
            itemAmounts: ((_t = (_s = trip.budgetDetails) === null || _s === void 0 ? void 0 : _s.budgetItems) !== null && _t !== void 0 ? _t : []).reduce(function (acc, item) {
                acc[item.categoryCode] = item.amount;
                return acc;
            }, {}),
        },
        privacy: mapApiPrivacyToWizard((_u = trip.privacySetting) !== null && _u !== void 0 ? _u : "invite-only"),
        allowJoinRequests: trip.privacySetting !== "public",
        maxParticipants: (_v = trip.maxParticipants) !== null && _v !== void 0 ? _v : 0,
        invitedParticipants: ((_w = trip.participants) !== null && _w !== void 0 ? _w : []).map(function (p) {
            var _a;
            return ({
                id: p.id.toString(),
                name: p.name,
                email: "",
                role: "Member",
                avatarUrl: (_a = p.profileImageUrl) !== null && _a !== void 0 ? _a : "",
            });
        }),
        itinerary: ((_x = trip.itinerary) !== null && _x !== void 0 ? _x : []).map(function (item, idx) {
            var _a;
            return ({
                id: "day-".concat(idx + 1),
                day: item.day || String(idx + 1),
                title: item.title,
                description: item.description,
                activities: ((_a = item.activities) !== null && _a !== void 0 ? _a : []).map(function (activity) {
                    var _a, _b, _c;
                    return ({
                        id: "activity-".concat(idx + 1, "-1"),
                        time: activity.time,
                        title: (_a = activity.title) !== null && _a !== void 0 ? _a : "",
                        location: (_b = activity.location) !== null && _b !== void 0 ? _b : "",
                        description: (_c = activity.description) !== null && _c !== void 0 ? _c : "",
                    });
                }),
            });
        }),
        logistics: {
            accommodation: {
                hotelName: "",
                address: "",
                checkIn: null,
                checkOut: null,
                confirmationFile: null,
            },
            transport: {
                number: "",
                tickets: null,
            },
        },
    };
};
var mapWizardDataToApiPayload = function (data) {
    var formattedStartDate = data.startDate
        ? data.startDate.format("DD-MM-YYYY")
        : "";
    var formattedEndDate = data.endDate
        ? data.endDate.format("DD-MM-YYYY")
        : "";
    var coverImageFromWizard = typeof data.coverImage === "string" && !data.coverImage.startsWith("data:")
        ? data.coverImage
        : null;
    return {
        tripName: data.tripTitle,
        source: data.source,
        destination: data.destination,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        description: data.description,
        highlights: data.highlights.map(function (item) { return item.trim(); }),
        inclusions: data.inclusions.map(function (item) { return item.trim(); }),
        exclusions: data.exclusions.map(function (item) { return item.trim(); }),
        itinerary: data.itinerary,
        coverImage: coverImageFromWizard,
        coverImageFile: undefined,
        coverImageUrl: null,
        galleryImages: [],
        videoUrl: "",
        privacySetting: data.privacy,
        locationDetails: {
            latitude: null,
            longitude: null,
            meetingPoint: data.meetingPoint,
            meetingTime: data.meetingTime,
        },
        modeOfTransport: data.modeOfTransport,
        maxParticipant: data.maxParticipants,
        status: "YET_TO_START",
        tripCategories: data.tripCategories
            .map(function (item) { return String(item.value); })
            .filter(function (code) { return code.length > 0; }),
        budgetDetails: parseBudgetPayload(data.budget),
    };
};
var totalSteps = 5;
var DRAFTS_LIST_KEY = "CREATE_TRIP_DRAFTS";
var CreateTripWizard = function () {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var tripId = useParams().tripId;
    var _a = useState(tripId ? Number(tripId) : null), originalTripBeingEdited = _a[0], setOriginalTripBeingEdited = _a[1];
    var _b = useState(false), draftExistsForTrip = _b[0], setDraftExistsForTrip = _b[1];
    var _c = useState(null), draftIdForTrip = _c[0], setDraftIdForTrip = _c[1];
    var _d = useState(null), successDetails = _d[0], setSuccessDetails = _d[1];
    var isLoading = useSelector(function (state) { return state.ui.isLoading; });
    var _e = useState(1), currentStep = _e[0], setCurrentStep = _e[1];
    //const [
    //  ,/*tripData*/
    /*setTripData*/
    //] = useState<CreateTripFormData>(initialTripData);
    var _f = useState(false), showDraftBanner = _f[0], setShowDraftBanner = _f[1];
    var _g = useState(!!(originalTripBeingEdited || tripId)), showEditBanner = _g[0], setShowEditBanner = _g[1];
    var _h = useState(0), draftCount = _h[0], setDraftCount = _h[1];
    var _j = useState(null), activeDraftId = _j[0], setActiveDraftId = _j[1];
    var _k = useState({}), validationErrors = _k[0], setValidationErrors = _k[1];
    var _l = useState(null), pendingDraftToApply = _l[0], setPendingDraftToApply = _l[1];
    var _m = useState(false), showApplyDraftDialog = _m[0], setShowApplyDraftDialog = _m[1];
    // formik will hold the authoritative form state
    var formik = useFormik({
        initialValues: CreateTripFormInitialData,
        validationSchema: getSchemaForStep(currentStep),
        enableReinitialize: true,
        onSubmit: function () {
            /* submission handled elsewhere */
        },
    });
    var tripData = formik.values;
    var updateTripData = function (fields) {
        formik.setValues(function (prev) { return (__assign(__assign({}, prev), fields)); });
    };
    var saveDraftToStorage = function (data) {
        saveToLocalStorage(CREATE_TRIP_KEY, serializeDraft(data));
    };
    var getSavedDrafts = function () {
        return loadFromLocalStorage(DRAFTS_LIST_KEY, []);
    };
    var saveDraftToList = function (data) {
        var _a, _b, _c;
        var list = getSavedDrafts() || [];
        var serialized = serializeDraft(data);
        // If we have an active draft id, try to update that entry
        if (activeDraftId) {
            var existingIndex_1 = list.findIndex(function (d) { return d.id === activeDraftId; });
            if (existingIndex_1 !== -1) {
                var existing = list[existingIndex_1];
                var updatedItem = __assign(__assign({}, existing), { name: ((_a = data.tripTitle) === null || _a === void 0 ? void 0 : _a.trim()) || existing.name, data: serialized, createdAt: new Date().toLocaleString() });
                var remaining = list.filter(function (_, i) { return i !== existingIndex_1; });
                var updated_1 = __spreadArray([updatedItem], remaining, true);
                if (updated_1.length > 10)
                    updated_1.pop();
                saveToLocalStorage(DRAFTS_LIST_KEY, updated_1);
                saveToLocalStorage(CREATE_TRIP_KEY, updatedItem.data);
                setDraftCount(updated_1.length);
                setActiveDraftId(updatedItem.id);
                return { ok: true, item: updatedItem };
            }
        }
        // If editing a published trip (tripId present), try to update an existing draft for that trip
        if (tripId) {
            var existingByTrip_1 = list.findIndex(function (d) { return d.originalTripId === Number(tripId); });
            if (existingByTrip_1 !== -1) {
                var existing = list[existingByTrip_1];
                var updatedItem = __assign(__assign({}, existing), { name: ((_b = data.tripTitle) === null || _b === void 0 ? void 0 : _b.trim()) || existing.name, data: serialized, createdAt: new Date().toLocaleString() });
                var remaining = list.filter(function (_, i) { return i !== existingByTrip_1; });
                var updated_2 = __spreadArray([updatedItem], remaining, true);
                if (updated_2.length > 10)
                    updated_2.pop();
                saveToLocalStorage(DRAFTS_LIST_KEY, updated_2);
                saveToLocalStorage(CREATE_TRIP_KEY, updatedItem.data);
                setDraftCount(updated_2.length);
                setActiveDraftId(updatedItem.id);
                setDraftExistsForTrip(true);
                setDraftIdForTrip(updatedItem.id);
                return { ok: true, item: updatedItem };
            }
        }
        // otherwise create a new draft
        var id = "draft-".concat(Date.now());
        var item = {
            id: id,
            name: ((_c = data.tripTitle) === null || _c === void 0 ? void 0 : _c.trim()) || "Draft ".concat(list.length + 1),
            data: serialized,
            createdAt: new Date().toLocaleString(),
            // preserve whether this draft originated from an existing published trip
            originalTripId: tripId ? Number(tripId) : null,
            isPublishedEdit: !!tripId,
        };
        // prepend new draft and evict oldest if exceeding 10
        var updated = __spreadArray([item], list, true);
        if (updated.length > 10) {
            updated.pop();
        }
        saveToLocalStorage(DRAFTS_LIST_KEY, updated);
        // also set as current working draft
        saveToLocalStorage(CREATE_TRIP_KEY, item.data);
        setDraftCount(updated.length);
        setActiveDraftId(item.id);
        return { ok: true, item: item };
    };
    var debouncedSaveDraft = useCallback(debounce(function (values) {
        saveDraftToStorage(values);
    }, 10000), []);
    useEffect(function () {
        debouncedSaveDraft(tripData);
        return function () {
            debouncedSaveDraft.cancel();
        };
    }, [tripData, debouncedSaveDraft]);
    var handleSaveDraft = function () {
        var res = saveDraftToList(tripData);
        if (!res.ok) {
            dispatch(setSnackbar({
                message: "Unable to save draft",
                severity: "warning",
                open: true,
            }));
            return;
        }
        dispatch(setSnackbar({ message: "Draft saved!", severity: "success", open: true }));
        setShowDraftBanner(true);
    };
    var dataURLtoFile = function (dataurl, filename) {
        var _a;
        var arr = dataurl.split(",");
        var mime = ((_a = arr[0].match(/:(.*?);/)) === null || _a === void 0 ? void 0 : _a[1]) || "image/png";
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };
    var handlePublishTrip = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, finalCoverImageUrl, fileToUpload, formData, uploadResponse, res, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(setLoading(true));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 9, 10, 11]);
                    payload = mapWizardDataToApiPayload(tripData);
                    finalCoverImageUrl = null;
                    fileToUpload = null;
                    if (tripData.coverImageFile instanceof File) {
                        fileToUpload = tripData.coverImageFile;
                    }
                    else if (tripData.coverImage &&
                        typeof tripData.coverImage === "string" &&
                        tripData.coverImage.startsWith("data:")) {
                        fileToUpload = dataURLtoFile(tripData.coverImage, "cover-image.png");
                    }
                    if (!fileToUpload) return [3 /*break*/, 3];
                    formData = new FormData();
                    formData.append("file", fileToUpload);
                    return [4 /*yield*/, uploadFile(formData)];
                case 2:
                    uploadResponse = _b.sent();
                    finalCoverImageUrl = ((_a = uploadResponse === null || uploadResponse === void 0 ? void 0 : uploadResponse.result) === null || _a === void 0 ? void 0 : _a.result) || null;
                    return [3 /*break*/, 4];
                case 3:
                    if (tripData.coverImage &&
                        typeof tripData.coverImage === "string" &&
                        !tripData.coverImage.startsWith("data:")) {
                        finalCoverImageUrl = tripData.coverImage;
                    }
                    _b.label = 4;
                case 4:
                    payload.coverImage = finalCoverImageUrl;
                    delete payload.coverImageFile;
                    res = void 0;
                    if (!tripId) return [3 /*break*/, 6];
                    return [4 /*yield*/, updateTrip(tripId, payload)];
                case 5:
                    res = _b.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, createTrip(payload)];
                case 7:
                    res = _b.sent();
                    _b.label = 8;
                case 8:
                    console.log("create trip response: ", res);
                    if ((res === null || res === void 0 ? void 0 : res.statusCode) === StatusCodes.SUCCESS
                    //|| res?.statusCode === StatusCodes.TRIP_UPDATED
                    ) {
                        clearFromLocalStorage(CREATE_TRIP_KEY);
                        setSuccessDetails({
                            tripId: res.result.tripId,
                            groupCode: res.result.groupCode,
                        });
                        setCurrentStep(6);
                        /*         dispatch(
                          setSnackbar({
                            message: "Trip saved successfully!",
                            severity: "success",
                            open: true,
                          }),
                        ); */
                        //const newTripId = res?.result?.id || tripId;
                        /* if (newTripId) {
                          navigate(`${endpoints.web.tripDetails}/${newTripId}`);
                        } */
                    }
                    else {
                        dispatch(setSnackbar({
                            message: "Unable to save trip. Please try again.",
                            severity: "error",
                            open: true,
                        }));
                    }
                    return [3 /*break*/, 11];
                case 9:
                    error_1 = _b.sent();
                    console.error("Error publishing trip", error_1);
                    dispatch(setSnackbar({
                        message: "Error saving trip. Please try again.",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 11];
                case 10:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var fetchTripDetails = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var trip, wizardData, _a, drafts, existing, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(setLoading(true));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, getTripDetails(id)];
                case 2:
                    trip = _b.sent();
                    wizardData = mapTripToWizardData(trip);
                    _a = wizardData;
                    return [4 /*yield*/, normalizeTripCategoriesForForm(wizardData.tripCategories)];
                case 3:
                    _a.tripCategories = _b.sent();
                    formik.setValues(wizardData);
                    // after loading a published trip for editing, check if a draft already exists for this trip
                    try {
                        drafts = getSavedDrafts() || [];
                        existing = drafts.find(function (d) { return d.originalTripId === Number(id); });
                        if (existing) {
                            setDraftExistsForTrip(true);
                            setDraftIdForTrip(existing.id);
                            // Show in-page dialog to ask user if they'd like to apply the draft
                            setPendingDraftToApply(existing);
                            setShowApplyDraftDialog(true);
                            // ensure edit banner displays
                            setShowEditBanner(true);
                        }
                        else {
                            setDraftExistsForTrip(false);
                            setDraftIdForTrip(null);
                        }
                    }
                    catch (e) {
                        // fail silently — drafts are optional
                        setDraftExistsForTrip(false);
                        setDraftIdForTrip(null);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _b.sent();
                    console.error("Failed to fetch trip details", error_2);
                    dispatch(setSnackbar({
                        message: "Unable to load trip details.",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (tripId) {
            fetchTripDetails(tripId);
            return;
        }
        // Do not auto-load any saved draft on mount. Only initialize draft count.
        var drafts = loadFromLocalStorage(DRAFTS_LIST_KEY, []);
        setDraftCount(drafts.length || 0);
    }, [tripId]);
    var clearCurrentDraft = function () {
        clearFromLocalStorage(CREATE_TRIP_KEY);
        formik.setValues(CreateTripFormInitialData);
        setShowDraftBanner(false);
        setActiveDraftId(null);
        setOriginalTripBeingEdited(null);
        dispatch(setSnackbar({ message: "Draft cleared", severity: "info", open: true }));
    };
    var resetForm = function () {
        formik.setValues(CreateTripFormInitialData);
        clearFromLocalStorage(CREATE_TRIP_KEY);
        setShowDraftBanner(false);
        setActiveDraftId(null);
        setOriginalTripBeingEdited(null);
        dispatch(setSnackbar({
            message: "Form reset",
            severity: "info",
            open: true,
        }));
    };
    var openDraftsModal = function () {
        dispatch(setModal({
            name: ModalKeys.DRAFTS,
            props: {
                onApply: function (draft) {
                    if (draft === null || draft === void 0 ? void 0 : draft.data) {
                        formik.setValues(deserializeDraft(draft.data));
                        saveToLocalStorage(CREATE_TRIP_KEY, draft.data);
                        setShowDraftBanner(true);
                        setActiveDraftId(draft.id);
                        // if this draft was created while editing a published trip, remember that
                        if (draft.originalTripId)
                            setOriginalTripBeingEdited(Number(draft.originalTripId));
                        dispatch(setSnackbar({
                            message: "Draft applied",
                            severity: "success",
                            open: true,
                        }));
                    }
                },
                onChange: function () {
                    var drafts = loadFromLocalStorage(DRAFTS_LIST_KEY, []);
                    setDraftCount(drafts.length || 0);
                    if (activeDraftId && !drafts.find(function (d) { return d.id === activeDraftId; })) {
                        // active draft was deleted from the list
                        setActiveDraftId(null);
                        clearFromLocalStorage(CREATE_TRIP_KEY);
                        setShowDraftBanner(false);
                        // clear edit marker if active draft (from a published trip) was removed
                        setOriginalTripBeingEdited(null);
                    }
                },
            },
        }));
    };
    var renderCurrentStep = function () {
        switch (currentStep) {
            case 1:
                return (_jsx(TripBasicsForm, { data: tripData, updateData: updateTripData, onNext: function () { return setCurrentStep(2); }, validationErrors: validationErrors }));
            case 2:
                return (_jsx(TripDetailsForm, { data: tripData, updateData: updateTripData, onNext: function () { return setCurrentStep(2); }, validationErrors: validationErrors }));
            case 3:
                return (_jsx(PrivacyParticipantsForm, { data: tripData, updateData: updateTripData, validationErrors: validationErrors }));
            case 4:
                return (_jsx(ItineraryLogisticsForm, { data: tripData, updateData: updateTripData, validationErrors: validationErrors }));
            case 5:
                return _jsx(ReviewPublishStep, { data: tripData, onEdit: setCurrentStep });
            case 6:
                return successDetails ? (_jsx(TripSuccessStep, { data: tripData, successDetails: successDetails, onViewTrip: function () {
                        return navigate("".concat(endpoints.web.tripDetails, "/").concat(successDetails.tripId));
                    }, onGoToDashboard: function () { return navigate(endpoints.web.manageTrips); } })) : null;
            default:
                break;
        }
    };
    // Dynamic labels based on the flow: Basics -> Privacy -> Inclusions -> Itinerary
    var getNextButtonLabel = function () {
        switch (currentStep) {
            case 1:
                return "Next: Details";
            case 2:
                return "Next: Privacy";
            case 3:
                return "Next: Inclusions";
            case 4:
                return "Next: Itinerary";
            case 5:
                return tripId ? "Save Changes" : "Create Trip";
            default:
                return "Next";
        }
    };
    var getStepLabel = function () {
        switch (currentStep) {
            case 1:
                return "Trip Basics";
            case 2:
                return "Trip Details";
            case 3:
                return "Privacy";
            case 4:
                return "Itinerary";
            case 5:
                return "Review";
            case 6:
                return "Trip Published";
            default:
                return "";
        }
    };
    var progressValue = Math.round(((currentStep - 1) / totalSteps) * 100);
    var handleNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var schema, err_1, errors_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (currentStep === 5) {
                        handlePublishTrip();
                        return [2 /*return*/];
                    }
                    schema = getSchemaForStep(currentStep);
                    console.log(schema, currentStep);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, schema.validate(formik.values, { abortEarly: false })];
                case 2:
                    _a.sent();
                    // clear any previous errors for the step
                    setValidationErrors({});
                    formik.setErrors({});
                    if (currentStep < totalSteps)
                        setCurrentStep(function (prev) { return prev + 1; });
                    console.log("step updated");
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.log("errors: ", err_1);
                    if (err_1 && err_1.inner && Array.isArray(err_1.inner)) {
                        errors_1 = {};
                        err_1.inner.forEach(function (e) {
                            if (e.path && !errors_1[e.path])
                                errors_1[e.path] = e.message;
                        });
                        console.log("errorsssss: ", errors_1);
                        setValidationErrors(errors_1);
                        formik.setErrors(errors_1);
                        dispatch(setSnackbar({
                            message: "Please fill required fields before proceeding.",
                            severity: "warning",
                            open: true,
                        }));
                    }
                    else {
                        console.error("Validation error", err_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleBack = function () {
        if (currentStep > 1)
            setCurrentStep(function (prev) { return prev - 1; });
    };
    if (isLoading) {
        return (_jsx(WrapperContainer, { "$background": "#f8f9fa", "$minHeight": "100vh", "$padding": "32px 32px 100px 32px", "$margin": "5rem 0 0 0", children: _jsx(CustomText, { "$fontSize": "18px", "$fontWeight": "600", children: "Loading trip details..." }) }));
    }
    console.log("trip form data: ", tripData);
    return (_jsxs(WrapperContainer, { "$background": "#f8f9fa", "$minHeight": "100vh", "$padding": "0px 32px 100px 32px", "$margin": "5rem 0 0 0", "$flexDirection": "column", children: [currentStep !== 6 && (_jsxs(_Fragment, { children: [_jsxs(Box, { maxWidth: "100%", children: [_jsxs(CustomText, { "$fontSize": "14px", "$fontWeight": "600", "$margin": "0 0 8px 0", children: ["Step ", currentStep, " of ", totalSteps, ": ", getStepLabel()] }), _jsx(LinearProgress, { variant: "determinate", value: progressValue, sx: {
                                    height: 6,
                                    borderRadius: 3,
                                    backgroundColor: "#e8eaed",
                                    "& .MuiLinearProgress-bar": { backgroundColor: "#1a73e8" },
                                } }), _jsxs(CustomText, { "$fontSize": "12px", "$color": "#5f6368", "$margin": "8px 0 0 0", children: [progressValue, "% complete"] })] }), (originalTripBeingEdited || tripId) && showEditBanner && (_jsxs(Alert, { severity: "warning", onClose: function () { return setShowEditBanner(false); }, sx: { mt: 2 }, children: ["You are editing an existing trip", originalTripBeingEdited
                                ? " (ID: ".concat(originalTripBeingEdited, ")")
                                : "", "."] })), _jsxs(Dialog, { open: showApplyDraftDialog, onClose: function () {
                            setShowApplyDraftDialog(false);
                            setPendingDraftToApply(null);
                        }, children: [_jsx(DialogTitle, { children: "Saved draft found" }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: "A saved draft exists for this trip. Would you like to load the draft now?" }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: function () {
                                            setShowApplyDraftDialog(false);
                                            setPendingDraftToApply(null);
                                        }, children: "Cancel" }), _jsx(Button, { variant: "contained", onClick: function () {
                                            if (pendingDraftToApply) {
                                                try {
                                                    var deserialized = deserializeDraft(pendingDraftToApply.data);
                                                    formik.setValues(deserialized);
                                                    saveToLocalStorage(CREATE_TRIP_KEY, pendingDraftToApply.data);
                                                    setShowDraftBanner(true);
                                                    setActiveDraftId(pendingDraftToApply.id);
                                                    setOriginalTripBeingEdited(Number(pendingDraftToApply.originalTripId));
                                                    dispatch(setSnackbar({
                                                        message: "Draft applied",
                                                        severity: "success",
                                                        open: true,
                                                    }));
                                                }
                                                catch (e) {
                                                    console.error("Failed to apply draft:", e);
                                                }
                                            }
                                            setShowApplyDraftDialog(false);
                                            setPendingDraftToApply(null);
                                        }, children: "Apply Draft" })] })] }), _jsx(WrapperContainer, { "$flexDirection": "row-reverse", "$padding": "0", children: _jsxs(Stack, { direction: "row", spacing: 1, alignItems: "end", children: [_jsx(Button, { onClick: resetForm, variant: "outlined", sx: { textTransform: "none" }, children: "Reset Form" }), _jsx(Badge, { badgeContent: draftCount, color: "primary", children: _jsx(Button, { onClick: openDraftsModal, variant: "contained", sx: { textTransform: "none" }, children: "Open Drafts" }) })] }) })] })), renderCurrentStep(), currentStep !== 6 && (_jsx(_Fragment, { children: _jsx(Box, { sx: {
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: "#fff",
                        borderTop: "1px solid #dadce0",
                        padding: "20px 32px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        zIndex: 1000,
                    }, children: _jsxs(_Fragment, { children: [_jsx(Box, { sx: { width: "150px" }, children: currentStep > 1 && (_jsx(Button, { onClick: handleBack, sx: {
                                        backgroundColor: "#e8eaed", // Light gray background
                                        color: "#202124",
                                        borderRadius: "12px",
                                        padding: "10px 24px",
                                        textTransform: "none",
                                        fontWeight: 700,
                                        "&:hover": { backgroundColor: "#dadce0" },
                                    }, children: "Back" })) }), _jsxs(Stack, { direction: "row", spacing: 2, children: [_jsx(Button, { onClick: handleSaveDraft, variant: "outlined", sx: {
                                            borderRadius: "12px",
                                            textTransform: "none",
                                            fontWeight: 700,
                                            px: 3,
                                        }, children: "Save as Draft" }), _jsx(Button, { onClick: handleNext, variant: "contained", sx: {
                                            backgroundColor: "#4285f4", // Corporate blue
                                            color: "#fff",
                                            borderRadius: "12px",
                                            padding: "10px 32px",
                                            textTransform: "none",
                                            fontWeight: 700,
                                            boxShadow: "none",
                                            "&:hover": {
                                                backgroundColor: "#1967d2",
                                                boxShadow: "none",
                                            },
                                        }, children: getNextButtonLabel() })] })] }) }) }))] }));
};
export default CreateTripWizard;
